import { IconProps, IconSize } from "../theme";

const EmptyCircle: React.FC<IconProps> = ({ size = IconSize.M }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="11.5" stroke="black" strokeOpacity="0.2" />
    </svg>
  );
};

export default EmptyCircle;
